

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],

      comercios_f: [],

      f_c: {
        desde: this.date_rest(this.currentdate(), -14),
        hasta: this.currentdate(),
      }

    };
  },

  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis=' + window.sssdi + '&a=liquidacionNJnvo' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta
    }
  },

  mounted: function () {

    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true

    });

    $('.box').boxWidget();

 

  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();

      this.$http
        .post('/SERVER/scd/reportes/', {
          'a': 'liquidacionNJnvo',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status == 1) {

            response.data.data.forEach(row => {

              for (let i = 4; i < 20; i++) {
                row[i] = this.num_to_many(row[i]);
              }
              this.tbv.row.add(row);
            });

          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/liquidacionNJnvo/tventas/tventas.js